import React from 'react'
import cn from 'classnames'
import TeamIcon from 'components/users/TeamIcon'
import PublicIcon from 'components/shared/icons/PublicIcon'
import PrivateIcon from 'components/shared/icons/PrivateIcon'
import LinkIcon from 'components/shared/icons/LinkIcon'
import HodlockerIcon from 'components/shared/icons/HodlockerIcon'
import TreechatIcon from 'components/shared/icons/TreechatIconPng'
import TwetchIcon from 'components/shared/icons/TwetchIcon'
import questModel from 'components/quests/questModel'
import styles from 'components/quests/stream-icon.module.scss'

export default function StreamIcon({ quest, isRoot, contextStyles }) {
    const isPublic = questModel.isPublic(quest)
    const isHodlocker = gon.HODLOCKER_TEAM_ID && gon.HODLOCKER_TEAM_ID === quest.team_id
    const isTwetch = gon.TWETCH_TEAM_ID && gon.TWETCH_TEAM_ID === quest.team_id

    const showHodlocker = isHodlocker
    const showTwetch = isTwetch
    const showPublic = isPublic
    const showTeam = questModel.hasTeam(quest) && !(isTwetch || isHodlocker)

    return (
        <div className={styles.streamIconComp}>
            {questModel.isPrivate(quest) && (
                <PrivateIcon
                    contextStyles={cn(styles.permsIcon, styles.privateIcon, contextStyles)}
                />
            )}

            {showHodlocker && (
                <HodlockerIcon
                    contextStyles={cn(styles.permsIcon, styles.hodlockerIcon, contextStyles)}
                />
            )}

            {showTwetch && (
                <TwetchIcon
                    contextStyles={cn(styles.permsIcon, styles.twetchIcon, contextStyles)}
                />
            )}

            {showPublic && (
                <PublicIcon
                    contextStyles={cn(styles.permsIcon, styles.publicIcon, contextStyles)}
                />
            )}

            {questModel.isLinkShare(quest) && (
                <LinkIcon contextStyles={cn(styles.permsIcon, styles.linkIcon, contextStyles)} />
            )}

            {showTeam && (
                <TeamIcon
                    team={quest.team}
                    contextStyles={cn(styles.permsIcon, styles.initialStyles, contextStyles)}
                    quest={quest}
                />
            )}
        </div>
    )
}
